// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EnglishMoja_wrapper__13qVH","heading":"EnglishMoja_heading__38fjg","contact__btn":"EnglishMoja_contact__btn__3szNc"};